var React = require('react');
var hoistNonReactStatics = require('hoist-non-react-statics');

function	provideContext(Component, customContextTypes) {
    var childContextTypes = Object.assign({
    }, customContextTypes || {});

    var ContextProvider = React.createClass({
        displayName: 'ContextProvider',

        propTypes: {
            context: React.PropTypes.object.isRequired
        },

        childContextTypes: childContextTypes,

        getChildContext: function () {
            var childContext = {};
            if (customContextTypes) {
                Object.keys(customContextTypes).forEach(function (key) {
                    childContext[key] = this.props.context[key];
                }, this);
            }
            return childContext;
        },

        render: function () {
            return React.createElement(Component, Object.assign({}, this.props, { ref: 'wrappedElement' }));
        }
    });

    hoistNonReactStatics(ContextProvider, Component);

    return ContextProvider;
}

module.exports = provideContext;



/** WEBPACK FOOTER **
 ** ./app/addons/context.js
 **/